import * as Yup from 'yup';
import { EFormTags } from '../../../../shared/interfaces/form-interfaces';

export const form = [
  {
    id: 'RecoverPasswordForm',
    items: [
      {
        name: 'email',
        type: 'email',
        label: 'Email',
        tag: EFormTags.textField,
      },
    ],
  },
];

export const schema = Yup.object().shape({
  email: Yup.string()
    .required('Email é obrigatório')
    .email('Digite um email válido'),
});

export const initialData = {
  email: '',
};
